import { getCookie, getOATokenCookie ,setCookie, removeCookie, removeOATokenCookie } from '@/utils/cookies';
import { TOKEN_KEY, FPL_TOKEN_KEY } from '@/config/defaultSetting';

export function getToken(): string | undefined {
  return getCookie(TOKEN_KEY);
}

export function getFPLToken() {
  return getCookie(FPL_TOKEN_KEY);
}

export function getOAToken() {
  return getOATokenCookie();
}

export function setToken(value: string) {
  return setCookie(TOKEN_KEY, value);
}

export function removeToken() {
  removeCookie(TOKEN_KEY);
}

export function removeFPLToken() {
  removeCookie(FPL_TOKEN_KEY);
}

export function removeOACookie() {
  removeOATokenCookie();
}
